
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      vxSearchPageTitle: 'search/getSearchPageTitle',
      vxCollectionTitle: 'search/getCollectionTitle',
      vxPageDescription: 'search/getPageDescription',
    }),
    pageTitle() {
      return this.vxCollectionTitle || this.vxSearchPageTitle
    },
  },
}
